import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext } from 'react';
import { Accordion, AccordionContext, Card, Container, useAccordionToggle } from 'react-bootstrap';
import './Faq.scss';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { FullscreenLoader } from '../FullscreenLoader/FullscreenLoader';

const FaqComponent = () => {
  const { staticData } = useFirebase();

  if (!staticData || !Object.keys(staticData).length) return <FullscreenLoader fullscreen={false} />;

  return (
    <div className={'my-5'}>
      <Accordion>
        {(staticData.faqs || []).map((faq) => {
          return (
            <Card key={faq.id} className={'faq-card'}>
              <ContextAwareToggle eventKey={faq.id}>{faq.question}</ContextAwareToggle>
              <Accordion.Collapse eventKey={faq.id}>
                <Card.Body className={'faq-body pb-1'}>
                  {faq.answer.map((segment, i) => (
                    <p key={i.toString()} className={'text-left'}>{segment}</p>
                  ))}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          );
        })}
      </Accordion>
    </div>
  );
};

const ContextAwareToggle = ({ children, eventKey, callback = null }) => {
  const currentEventKey = useContext(AccordionContext);
  const decoratedOnClick = useAccordionToggle(eventKey, () => callback && callback(eventKey));
  const isCurrentEventKey = currentEventKey === eventKey;

  return (
    <Card.Header className="faq-header" onClick={decoratedOnClick}>
      <div className="d-flex justify-content-between align-items-center">
        {children}
        <FontAwesomeIcon icon={isCurrentEventKey ? faChevronUp : faChevronDown} />
      </div>
    </Card.Header>
  );
};

export { FaqComponent as Faq };
